import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { cancel } from '../state/actions.tsx';
import { getVersionName, isDialogVisible } from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import Content from './content/index.tsx';
import Footer from './footer/index.tsx';
import DeleteVersion from './DeleteModal.tsx';

const mapStateToProps = (state: State) => ({
	Content,
	Footer,
	isDialogVisible: isDialogVisible(state),
	versionName: getVersionName(state),
});

const mapDispatchToProps = {
	onClose: cancel,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(DeleteVersion);
